import { ReqFnFilter } from "../../../../shared/types";

export const everyone: ReqFnFilter = (student, program) => true;
